
import { Component, Vue } from "vue-property-decorator";
import ServicesNav from "@/components/Main/Services/ServicesNav.vue";
import ServicesBanner from "@/components/Main/Services/ServicesBanner.vue"
// import PublicPromocode from "@/components/Main/Services/PublicPromocode.vue";
import ServiceOS from "@/components/Main/Services/ServiceOS.vue";
import DexCardsModal from "@/components/Main/Services/Modals/DexCardsModal.vue";
import GiftInfo from "@/components/Main/Services/GiftInfo.vue";
@Component({
  components: {
    ServicesNav,
    ServicesBanner,
    ServiceOS,
    // PublicPromocode,
    DexCardsModal,
    GiftInfo
  },
})
export default class DexCards extends Vue {
  public isShowModal: boolean  = false;

  // methods
  public handleShowModal() {
    this.isShowModal = true
  }

  public handleCloseDexCardsModal() {
    this.isShowModal = false
  }
}
